import React from "react";
import "./LuxuryLineCredit.css";
import { Helmet } from "react-helmet-async";

const title = "Luxury Line of Credit";
const pageTitle =
  "Luxury Line of Credit | Unlock Cash Flow with Respected Solutions";
const metaDescription =
  "Access a flexible line of credit using your luxury assets as collateral. With Respected Solutions Luxury Line of Credit, you get fast cash while keeping full ownership.";

const LuxuryLineCredit = () => {
  return (
    <section className="luxury-line-credit-container">
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FinancialProduct",
            name: "Luxury Line of Credit",
            provider: {
              "@type": "Organization",
              name: "Respected Solutions",
            },
            areaServed: "NG",
          })}
        </script>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: "Luxury Line of Credit",
            url: "https://www.respectedsolution.co/luxury-line-credit",
          })}
        </script>
        <title>{pageTitle}</title>
        <meta name="description" content={metaDescription} />
      </Helmet>

      <div
        className="luxury-line-credit-hero-slide"
        style={{ backgroundImage: `url(/assets/images/rs/gold_bar.jpg)` }}
      >
        <div className="luxury-line-credit-hero-overlay">
          <div className="luxury-line-credit-hero-content">
            <h1>{title}</h1>
            <p>Access Cash While Keeping Ownership</p>
          </div>
        </div>
      </div>

      <div className="luxury-line-credit-inner">
        <div className="luxury-line-credit-inner-content">
          <section className="luxury-line-credit-intro">
            <p>
              A revolving facility that lets you access funds whenever you need
              them.
            </p>
            <p>
              Turn the value of your luxury assets into flexible cash flow
              without having to sell them.
            </p>
          </section>

          <section className="luxury-line-credit-access">
            <h2>Access Cash While Keeping Ownership</h2>
            <p>
              With the Respected Solutions Luxury Line of Credit, your gold,
              diamonds, jewelries, or luxury wristwatches can serve as
              collateral for quick, repeat access to cash.
            </p>
            <p>
              Draw only what you need, repay at your pace, and tap into the line
              again whenever necessary. Your assets remain yours, safely secured
              and fully insured for as long as they're in our care.
            </p>
          </section>

          <section className="luxury-line-credit-why">
            <h2>Why Choose Our Credit Line?</h2>
            <ul>
              <li>Fast access once your facility is set up</li>
              <li>No guarantors, no long forms</li>
              <li>No credit bureau checks</li>
              <li>Flexible limits based on asset value</li>
              <li>Revolving line - apply once, use many times</li>
              <li>Same-day disbursement available</li>
            </ul>
          </section>

          <section className="luxury-line-credit-how">
            <h2>How It Works</h2>
            <ul>
              <li>
                <strong>1. Start Your Application - </strong> Online, by phone,
                or in person
              </li>
              <li>
                <strong>2. Present Your Asset - </strong> We provide secure
                handling and insured storage, or you can visit us directly
              </li>
              <li>
                <strong>3. Get Your Funds - </strong> Agree to the terms, sign
                the paperwork, and receive instant transfer of your cash
              </li>
            </ul>
            <p>
              When you repay, your items are either returned to you immediately
              or can remain in safe custody, so you can draw on your credit line
              again whenever you choose.
            </p>
          </section>

          <section className="luxury-line-credit-eligible">
            <h2>Eligible Collateral</h2>
            <ul>
              <li>
                Luxury wristwatches (Rolex, Audemars Piguet, Patek Philippe,
                Richard Mille, Cartier, etc.)
              </li>
              <li>Gold</li>
              <li>Diamonds</li>
              <li>Fine Jewelry</li>
            </ul>
          </section>

          <div className="luxury-line-credit-seo-content">
            <h2>Flexible Credit & Investment Opportunities</h2>
            <p>
              Access asset-backed investment Nigeria and secured line of credit
              Nigeria with flexible terms. Our short-term investment Lagos
              options and partner investor program Nigeria provide flexible
              credit line Nigeria solutions. Grow your wealth with safe,
              high-yield opportunities backed by luxury assets.
            </p>
          </div>

          <section className="luxury-line-credit-modern">
            <h2>A Modern Way to Borrow</h2>
            <p>
              The Respected Solutions Luxury Line of Credit is built for
              flexibility. Instead of selling valuables or waiting through bank
              delays, you unlock liquidity while keeping full ownership of the
              things you value most.
            </p>
          </section>

          <section className="luxury-line-credit-cta">
            <h2>Ready to Apply?</h2>
            <p>
              Take advantage of your luxury assets today. With the Respected
              Solutions Luxury Line of Credit, you stay in control of your
              possessions while gaining the capital you need.
            </p>
            <a
              href="https://respectedsolution.com/borrow"
              className="luxury-line-credit-apply-btn"
              target="_blank"
              rel="noopener noreferrer"
            >
              Apply Now
            </a>
          </section>
        </div>
      </div>
    </section>
  );
};

export default LuxuryLineCredit;
